export const STAFF_TOKEN_KEY = 'san_gao_staff_token';
export const STAFF_INFO_KEY = 'san_gao_staff_info';

export function saveStaffSession(data) {
  localStorage.setItem(STAFF_TOKEN_KEY, data.token);
  localStorage.setItem(STAFF_INFO_KEY, JSON.stringify({
    orgId: data.orgId,
    orgName: data.orgName,
    autoAudit: data.autoAudit === true,
    taikangMode: data.taikangMode === true,
    personName: data.personName,
    personPhone: data.personPhone,
    organizations: Array.isArray(data.organizations) ? data.organizations : [],
  }));
}
